import { Component } from '@angular/core';
import { ButtonComponent } from '../../../common/components/button/button.component';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
  goHome(): void {
    window.location.href = window.location.origin;
  }
}
